<template lang="pug">
	div.detailTooltip
		p.detailTooltip-trigger
			span(
				tabindex="0",
				:style="styles.primary.background",
				@keypress.enter="toggle()", 
				@click="toggle()") i
		transition(name="fade")
			.detailTooltip-message(
				v-if="tip_open", 
				:style="styles.primary.color",
				@click="close()")
				.detailTooltip-inner(@click.stop.prevent="")
					.detailTooltip-close(
						tabindex="0",
						:style="styles.primary.color",
						@keypress.enter="close()",
						@click="close()")
					.detailTooltip-content(v-html="text")
</template>

<script>
import ID from '@/listing-app/mixins/ID'
import Theme from '@/listing-app/mixins/Theme'
export default {
	name: "Tooltip",
	mixins: [Theme, ID],
	props: ["text", "title", "tip_open"],
  data() {
    return {
      open: false,
      toggled: false
    }
  },
  methods: {
    toggle() {
      this.$emit("tooltipToggle", 'toggle')
    },
    close() {
      this.$emit("tooltipToggle", 'close')
    }
  }
}
</script>


<style lang="scss" scoped>
.detailTooltip {
  flex: 0 0 auto;
  display: inline-block;
}

.detailTooltip-trigger {
  margin: 0 0 0 0.5rem;
  line-height: 1;
  display: inline-block;
  span {
    font-style: italic;
    font-size: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    height: 20px;
    width: 20px;
    background: $black;
    color: $white;
    border-radius: 50%;
    justify-content: center;
    position: relative;
    text-transform: lowercase;
    font-family: "Times New Roman", Times, serif;
    transition: 0.25s ease;
    font-weight: 700;
    &:hover {
      background: $black !important;
    }
  }
}


.detailTooltip-message {
  position: fixed;
  top: 50%;
  left: 50%;
  display: flex;
  transform: translate(-50%, -50%);
  width: 800px;
  max-width: 85vw;
  max-height: 85vh;
	opacity: 1;
	z-index: 1000;
	pointer-events: all;
  &:after {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba($black, 0.75);
    height: 100vh;
    width: 100vw;
    z-index: -1;
		content: "";
		cursor: pointer;
  }

	&.fade-leave-active {
		transition: all 0s 0.25s linear, opacity 0.25s ease;
	}
	&.fade-enter-active {
    transition: all 0s 0s linear, opacity 0.25s ease;
	}
	&.fade-enter,
	&.fade-leave-to {
		opacity: 0;
		pointer-events: none;
		z-index: -1;
	}
}
.detailTooltip-inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-height: 100%;
	background: $white;
  border-top: 10px solid currentColor;
  padding: 2.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
  overflow-y: auto;
}

.detailTooltip-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  height: 1.25rem;
  width: 1.25rem;
  cursor: pointer;
  &:before,
  &:after {
    height: 100%;
    width: 3px;
    border-radius: 1.5px;
    position: absolute;
    background: currentColor;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    content: "";
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
}
.detailTooltip-content {
  padding: 0;
	color: $black;
	text-transform: none;
	font-weight: 500;
}
</style>